const specs = {
  standard: {
    operation: 'create',
    create: {
      type: 'bool',
      product: 'sitePlan_standard',
    },
  },
  droneShooting: {
    operation: 'update',
    update: {
      type: 'mapTo',
      target: '@{product.id} == "sitePlan_standard"',
      mapTo: [ 'droneShooting' ],
    },
  },
};


const dependencies = {
  hard: [],
  soft: [
    {
      if: {
        key: 'droneShooting',
        value: true,
      },
      then: {
        operation: 'createOrUpdate',
        createOrUpdate: {
          product: 'droneShooting_standard',
          service: 'droneShooting',
          with: { sitePlan: true },
        },
      },
    }
  ],
};


export default { specs, dependencies };
